module.exports = __webpack_public_path__ + "media/bootstrap-icons/thermometer-high-d95b2157.svg";